/**
 * Motif de refus renvoyé par l'API dans l'URL après un retour du fournisseur d'identité
 * (`/login?acces=desactive`).
 *
 * ⚠️ Il doit être capturé AU DÉMARRAGE, avant qu'Angular ne route. Le compte refusé revient sans
 * cookie : l'appel de `/api/me` répond 401, et l'intercepteur redirigeait alors vers `/login` en
 * **réécrivant l'URL sans le paramètre** — mesuré, le paramètre avait déjà disparu quand la page
 * s'affichait. Depuis le 2026-10-21, il ne redirige plus depuis une page de connexion, mais la
 * capture au démarrage reste la seule qui ne dépende d'aucune navigation.
 *
 * Capturé une seule fois depuis `main.ts`, avant `bootstrapApplication`.
 */
let motif: string | null = null;

export function capturerMotifRefus(): void {
  motif = new URLSearchParams(window.location.search).get('acces');
}

export function motifRefus(): string | null {
  return motif;
}
